import styled, { css } from 'styled-components'

export const Container = styled.div`
  padding: 0px 10px;
`

export const Option = styled.div`
  display: flex;
  align-items: center;
  font-size: 16px;
`

export const SelectWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 25px;

  > label {
    color: #FFF;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 10px;
  }
  #select-input {
    background: transparent;
    > div:first-child {
      border-radius: 6px;
      padding: 12px;
      background: #191B24;
    }
    > div:last-child {
      position: relative;
    }
    .select-arrow  {
      color: #C4C4C4;
      margin-left: 12px;
    }
    .item {
      padding: 10px 12px;
      white-space: nowrap;
    }
    #list {
      max-height: 200px;
      overflow: auto;
    }
  }

  ${({ isTop }) => isTop && css`
    #select-input {
      > div:first-child {
        background: #222430;
        padding: 16px 12px;
        font-weight: 600;
        color: #FFF;
      }
    }
  `}
`
